<template>
  <div class="content-430">
    <!-- <div class="item">学校：{{ info.schoolName }}</div>
    <div class="item">学期：{{ info.termName }}</div>
    <div class="item">学生姓名：{{ info.studentName }}</div>
    <div class="item">年级班级：{{ info.gradeClassName }}</div>
    <div class="item">家长手机：{{ info.parentPhone }}</div>
    <div class="item">课程分类：{{ classTypeArr[+info.classType] }}</div>
    <div class="item">原商品名称：{{ info.oldClassroomName }}</div>
    <div class="item">原上课时间：{{ info.oldTimeDesc }}</div>
    <div class="item">原金额：{{ info.oldClassroomFee? info.oldClassroomFee/100: info.oldClassroomFee }}</div>
    <div class="item">报名状态：{{ info.enrollStatus }}</div>
    <div class="item">调班课程名称：{{ info.newProductName }}</div>
    <div class="item">调班上课时间：{{ info.newTimeDesc }}</div>
    <div class="item">班级名称：{{ info.newClassName }}</div>
    <div class="item">调班金额：{{ info.newClassroomFee? info.newClassroomFee/100: info.newClassroomFee }}</div>
    <div class="item">调班课时：{{ info.newClassroomTime }}</div>
    <div class="item">调班状态：{{ info.convertStatus }}</div>
    <div class="item">调班时间：{{ info.createTime }}</div>
    <div class="item">调班操作人：{{ info.creatorName }}</div> -->
    <div class="form-head">基础信息</div>
    <div class="form-main">
      <Form ref="formInline" :model="info" inline label-position="left">
        <FormItem prop="schoolName" label="学校：">
          {{ info.schoolName }}
        </FormItem>
        <FormItem prop="termName" label="学期：">
          {{ info.termName }}
        </FormItem>
        <FormItem prop="schoolName" label="学生姓名：">
          {{ info.studentName }}
        </FormItem>
        <FormItem prop="gradeClassName" label="年级班级：">
          {{ info.gradeClassName }}
        </FormItem>
        <FormItem prop="parentPhone" label="家长手机：">
          {{ info.parentPhone }}
        </FormItem>
        <FormItem prop="newClassName" label="班级名称：">
          {{ info.newClassName }}
        </FormItem>
        <FormItem prop="classType" label="课程分类：">
          {{ classTypeArr[+info.classType] }}
        </FormItem>
      </Form>
    </div>

    <div class="form-head">原商品信息</div>
    <div class="form-main">
      <Form ref="formInline" :model="info" inline label-position="left">
        <Row>
          <FormItem prop="oldClassroomName" label="原商品名称：">
            {{ info.oldClassroomName }}
          </FormItem>
          <FormItem prop="oldTimeDesc" label="原上课时间：">
            {{ info.oldTimeDesc }}
          </FormItem>
        </Row>

        <FormItem prop="oldClassroomFee" label="课程金额（元）：">
          {{
            info.oldClassroomFee
              ? info.oldClassroomFee / 100
              : info.oldClassroomFee
          }}
        </FormItem>
        <FormItem prop="courseOrdFee" label="实收金额（元）：">
          {{
            info.courseOrdFee
              ? info.courseOrdFee / 100
              : info.courseOrdFee
          }}
        </FormItem>
        <FormItem prop="enrollStatus" label="报名状态："> 调班 </FormItem>
      </Form>
    </div>
    <div class="form-head">现商品信息</div>
    <div class="form-main">
      <Form ref="formInline" :model="info" inline label-position="left">
        <Row>
          <FormItem prop="newProductName" label="调班课程名称：">
            {{ info.newProductName }}
          </FormItem>
          <FormItem prop="newTimeDesc" label="调班上课时间：">
            {{ info.newTimeDesc }}
          </FormItem>
        </Row>
        <Row>
          <FormItem prop="newClassroomFee" label="调班课程金额（元）：">
            {{
              info.newClassroomFee
                ? info.newClassroomFee / 100
                : info.newClassroomFee
            }}
          </FormItem>
          <FormItem prop="newClassroomTime" label="调班课时：">
            {{ info.newClassroomTime }}
          </FormItem>
        </Row>

        <FormItem prop="convertStatus" label="调班状态："> 调班成功 </FormItem>
        <FormItem prop="createTime" label="调班时间：">
          {{ info.createTime }}
        </FormItem>
        <FormItem prop="creatorName" label="调班操作人：">
          {{ info.creatorName }}
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import courseSchedulCenterApi from '@/request/courseSchedulCenter/index';
export default {
  name: 'DetailPage',
  props: {
    exchangeId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      info: {},
      classTypeArr: ['', '素质课', '托管课'],
      enrollStatusArr: [],
      convertStatusArr: []
    };
  },
  // created() {
  //   this.classroomStudentRecDetail();
  // },
  methods: {
    async classroomStudentRecDetail() {
      const params = {
        exchangeId: this.exchangeId
      };
      const resp = await courseSchedulCenterApi.classroomStudentRecDetail(params);
      if (resp.status === 200) {
        console.log('resp', resp);
        this.info = resp.message;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-head {
  background: rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 24px;
}
.form-main {
  padding: 0 32px;
}
.item {
  height: 30px;
}
.content-430 {
  /deep/.ivu-form-item {
    width: 30%;
  }
}
</style>
